module.exports = __webpack_public_path__ + "NHLprat_round-14a9b337ad1c6b2a39d22b7d7914083c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/no/NHLprat_round.png
// module id = 1177
// module chunks = 1 2